export default __webpack_public_path__ + "a0ae77e23f5a98ce7e7c5498ad937c8bf55891170847b6a736d3c048e470ce9e.svg";